module.exports = __webpack_public_path__ + "static/media/linkedin.211b451c.svg";